import { Dialog } from '@hai/ui-react';
import React, { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { MetadataViewModel } from './metadata-models';

interface Props {
  itemsToDelete: MetadataViewModel[];
  onApply?: (items: MetadataViewModel[]) => void;
  onCancel?: VoidFunction;
}

export const MetadataDeleteConfirmModal: React.FunctionComponent<Props> = ({ itemsToDelete, onApply, onCancel }) => {
  const { t } = useTranslation();

  const handleDelete = (): void => {
    onApply(itemsToDelete);
  };
  
  const handleOnKeyUp = (e: React.KeyboardEvent<HTMLElement>): void => {    
    if (e.key === 'Enter') {
      if ((e.target as HTMLElement)?.id?.toString().includes('-submit')) {
        // from submit button, dont submit twice
        return;
      }
      handleDelete();
    }
  };  
  
    useLayoutEffect((): void => {
      const el = document.getElementById('delete-confirm-modal-submit');
      if (el) {
        el.focus();
      }
    }, []);

  return (
    <Dialog
      headline={t('metadata.settings.modal.delete.title', { count: itemsToDelete.length })}
          bodyText={`${t('metadata.settings.modal.delete.bodyText')} ${t('general.cannotUndo')}`}
      onClose={onCancel}
      onKeyUp={handleOnKeyUp}
      show={true}
      buttons={[
        { label: t('general.cancel') },
        { label: t('general.deleteBtn'), variant: 'danger', onClick: handleDelete, id: 'delete-confirm-modal-submit'  },
      ]}
    />
  );
};
